// --- Actions ---

// In Redux, actions are plain JavaScript objects that callers create to manipulate
// the application state. When an action is dispatched, Redux calls the reducers
// to arrive at the new application state kept in the Redux store. If this results
// in any significant changes to the store, Redux updates the application state and
// React responds by rerendering (only) the relevant parts of the page.

// Action types
export const SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS';
export const CLEAR_SEARCH_RESULTS = 'CLEAR_SEARCH_RESULTS';

// Action creators
export function setSearchResults({ searchTerm, result }) {
	return {
		type: SET_SEARCH_RESULTS,
		searchTerm,
		result
	};
}

export function clearSearchResults() {
	return {
		type: CLEAR_SEARCH_RESULTS
	};
}


// --- Initial State ---

// State will be mapped to the Redux store by combineReducers
const initialState = {
	hasResult: false,
	searchTerm: '',
	result: {
		gettingStarted: null,
		api: null,
		javascriptSdk: null,
		widgets: null
	}
};


// --- Reducer ---

//
// NOTE: A reducer is a 'pure' function that returns a part of the application state.
//       Given the same arguments, it should calculate the next state and return it.
//       No surprises. No side effects. No API calls. No mutations. Just a calculation.
//
// Things you should never do inside a reducer:
//   o Mutate its arguments
//   o Perform side effects like API calls and routing transitions
//   o Call non-pure functions, e.g.Date.now() or Math.random()
//   o Return undefined. Always initialize the state passed in with an optional default value
//
export default function searchReducer(state = initialState, action) {

	switch (action.type) {
		case SET_SEARCH_RESULTS:
			return {
				hasResult: true,
				searchTerm: action.searchTerm,
				result: {
					gettingStarted: action.result.gettingStarted || null,
					api: action.result.api || null,
					javascriptSdk: action.result.javascriptSdk || null,
					widgets: action.result.widgets || null
				}
			};
		case CLEAR_SEARCH_RESULTS:
			return {
				hasResult: false,
				searchTerm: '',
				result: { gettingStarted: null, api: null, javascriptSdk: null, widgets: null }
			};
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/searchReducer.js